import React from "react";
import "../Styles/GetCertifiedPage.css";

/* ===================================================
   DATA — edit copy/icons here, markup stays untouched
=================================================== */

const WHY_CARDS = [
  {
    title: "Build Employer Brand",
    desc: "Stand out as an employer of choice",
    icon: <img src="/assets/Build_Employer_Brand.png" alt="Build Employer Brand" />,
  },
  {
    title: "Attract Top Talent",
    desc: "Gain credibility with job seekers.",
    icon: <img src="/assets/Attract_Top_Talent.png" alt="Attract Top Talent" />,
  },
  {
    title: "Improve Employee Trust",
    desc: "Recognize and celebrate your workplace culture.",
    icon: <img src="/assets/Improve_Employee_Trust.png" alt="Improve Employee Trust" />,
  },
  {
    title: "Increase Brand Visibility",
    desc: "Get featured across Vanakkam HRD platforms.",
    icon: <img src="/assets/Increase_Brand_Visibility.png" alt="Increase Brand Visibility" />,
  },
];


const PROCESS_STEPS = [
  { number: "01", label: "Apply Online" },
  { number: "02", label: "Employee Survey" },
  { number: "03", label: "Expert Evaluation" },
  { number: "04", label: "Certification Awarded" },
];

const BENEFITS = [
  "Official Certification Badge",
  "Employer Branding Recognition",
  "Social Media & Website Features",
  "Certification & Digital Assets",
  "Increased Talent Attraction",
  "HR Community Recognition",
];

const CheckIcon = () => (
  <img src="/assets/check_icon_get.png" alt="Check" />
);


const ArrowIcon = () => (
  <img
    className="certify-arrow-icon"
    src="/assets/arrow _icon_get.png"
    alt="Arrow"
  />
);

/* ===================================================
   PAGE COMPONENT

   Hero photo + badge are both props — swap either from
   wherever you render <Getcertifiedpage /> without
   touching this file. The badge is a single designed
   image asset (not built from divs/text), so just point
   badgeImageSrc at that file.

   CTA links:
   - "Get Certified Now" -> https://outstandingworkplaces.co/
   - "Apply for Certification" -> https://outstandingworkplaces.co/nominate
   Both are external links, so they're rendered as <a> tags.
   onGetCertified / onApplyCertification still fire (e.g. for
   analytics) before the browser navigates.
=================================================== */

function Getcertifiedpage({
  // swap your real photo here (local import or URL)
  heroImageSrc = "/assets/get_bg.png",
  heroImageAlt = "Team celebrating an outstanding workplace certification",

  // badge is one image asset — point this at your real file
  showBadge = true,
  badgeImageSrc = "/assets/outstanding_workplaces_badge.png",
  badgeImageAlt = "Outstanding Workplaces — Certified 2026 India",

  onGetCertified = () => {},
  onApplyCertification = () => {},
}) {
  return (
    <>
      {/* ===================================================
          SECTION 1: CERTIFY HERO
      =================================================== */}
      <section className="certify-hero">
        <div className="certify-hero-container">
          <div className="certify-hero-left">
            <h1 className="certify-hero-title">
              Build a Workplace People Love.
              <span className="certify-hero-title-highlight">Get Recognized.</span>
            </h1>
            <p className="certify-hero-subtitle">
              Earn the Outstanding Workplaces Certification and showcase your commitment to
              employee experience, culture, and people-first leadership.
            </p>
            <a
              href="https://outstandingworkplaces.co/"
              className="certify-hero-btn"
              onClick={onGetCertified}
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Certified Now
              <ArrowIcon />
            </a>
          </div>

          <div className="certify-hero-right">
            {/* Everything below is positioned in % of this one "stage" box,
                so the photo + badge scale together identically at any
                screen size and stay pushed flush against the right edge
                of the container. */}
            <div className="certify-hero-stage">
              <img className="certify-hero-img" src={heroImageSrc} alt={heroImageAlt} />

              {showBadge && (
                <img
                  className="certify-hero-badge-img"
                  src={badgeImageSrc}
                  alt={badgeImageAlt}
                />
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ===================================================
          SECTION 2: WHY GET CERTIFIED
      =================================================== */}
      <section className="certify-why-section">
        <div className="certify-why-container">
          <h2 className="certify-why-heading">Why Get Certified?</h2>
          <div className="certify-why-underline" />

          <div className="certify-why-grid">
            {WHY_CARDS.map((card) => (
              <div className="certify-why-card" key={card.title}>
                <div className="certify-why-icon">{card.icon}</div>
                <h3 className="certify-why-card-title">{card.title}</h3>
                <p className="certify-why-card-desc">{card.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===================================================
          SECTION 3: CERTIFICATION PROCESS
      =================================================== */}
      <section className="certify-process-section">
        <div className="certify-process-container">
          <h2 className="certify-process-heading">Certification Process</h2>
          <div className="certify-process-underline" />

          <div className="certify-process-track">
            {PROCESS_STEPS.map((step, i) => (
              <React.Fragment key={step.number}>
                <div className="certify-process-step">
                  <div className="certify-process-circle">{step.number}</div>
                  <p className="certify-process-label">{step.label}</p>
                </div>
                {i < PROCESS_STEPS.length - 1 && <div className="certify-process-connector" />}
              </React.Fragment>
            ))}
          </div>
        </div>
      </section>

      {/* ===================================================
          SECTION 4: BENEFITS + CTA
      =================================================== */}
      <section className="certify-benefits-section">
        <div className="certify-benefits-container">
          <h2 className="certify-benefits-heading">Benefits</h2>
          <div className="certify-benefits-underline" />

          <div className="certify-benefits-grid">
            {BENEFITS.map((label) => (
              <div className="certify-benefits-item" key={label}>
                <span className="certify-benefits-check">
                  <CheckIcon />
                </span>
                <span className="certify-benefits-label">{label}</span>
              </div>
            ))}
          </div>

          <div className="certify-cta-box">
            <h3 className="certify-cta-title">Ready to Get Certified?</h3>
            <p className="certify-cta-desc">
              Join leading organizations that are creating exceptional workplaces and inspiring people.
            </p>
            <a
              href="https://outstandingworkplaces.co/nominate"
              className="certify-cta-btn"
              onClick={onApplyCertification}
              target="_blank"
              rel="noopener noreferrer"
            >
              Apply for Certification
            </a>
          </div>
        </div>
      </section>
    </>
  );
}

export default Getcertifiedpage;